<template>
  <div class="profile-marathon-gift-container">
    <category-block
      :target="category"
      position="position1"
      class="category-block category-block-1"
    />

    <CategoryTitle :category="category" />

    <GiftThresholdList />

    <category-block
      :target="category"
      position="position2"
      class="category-block category-block-2"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import CategoryTitle from "@/components/category/CategoryTitle.vue";

import login from "~/mixins/login";
import category from "~/mixins/category";
import deliveryReactive from "~/mixins/deliveryReactive";
import GiftThresholdList from "@/components/gift/GiftThresholdList.vue";

export default {
  name: "ProfileMarathonGift",
  mixins: [category, deliveryReactive, login],
  components: { CategoryTitle, GiftThresholdList },
  computed: {
    ...mapGetters({
      user: "cart/getUser"
    })
  }
};
</script>
